export const patternOptions = [
  { isGroup: true, label: "Bearish Continuations", color: "#db0671" },
  { value: "Unstructured Bear Flag", label: "Unstructured Flag", image: "/patterns/unstructured-bear-flag.png" },
  { value: "2 Touch Bear Flag", label: "2 Touch Flag", image: "/patterns/2-touch-bear-flag.png" },
  { value: "3 Touch Bear Flag", label: "3 Touch Flag", image: "/patterns/3-touch-bear-flag.png" },
  {
    value: "2 Touch Flat Bear Flag",
    label: "2 Touch Flat Flag",
    image: "/patterns/2-touch-flat-bear-flag.png"
  },
  {
    value: "3 Touch Flat Bear Flag",
    label: "3 Touch Flat Flag",
    image: "/patterns/3-touch-flat-bear-flag.png"
  },
  {
    value: "Symmetrical Bear Triangle",
    label: "Symmetrical Triangle",
    image: "/patterns/symmetrical-bear-triangle.png"
  },
  {
    value: "Expanding Bear Triangle",
    label: "Expanding Triangle",
    image: "/patterns/expanding-bear-triangle.png"
  },
  { value: "Advanced Bear Flag", label: "Advanced Flag", image: "/patterns/advanced-bear-flag.png" },
  { value: "Rising Wedge", label: "Rising Wedge", image: "/patterns/rising-wedge.png" },
  { value: "Ascending Channel", label: "Ascending Channel", image: "/patterns/ascending-channel.png" },
  { isGroup: true, label: "Bearish Reversals", color: "#db0671" },
  { value: "Head & Shoulders", label: "Head & Shoulders", image: "/patterns/head-shoulders.png" },
  { value: "Double Top", label: "Double Top", image: "/patterns/double-top.png" },
  { value: "Triple Top", label: "Triple Top", image: "/patterns/triple-top.png" },
  { value: "The Arc", label: "The Arc", image: "/patterns/bearish-arc.png" },
  { isGroup: true, label: "Bullish Continuations", color: "#0079cf" },
  { value: "Unstructured Bull Flag", label: "Unstructured Flag", image: "/patterns/unstructured-bull-flag.png" },
  { value: "2 Touch Bull Flag", label: "2 Touch Flag", image: "/patterns/2-touch-bull-flag.png" },
  { value: "3 Touch Bull Flag", label: "3 Touch Flag", image: "/patterns/3-touch-bull-flag.png" },
  {
    value: "2 Touch Flat Bull Flag",
    label: "2 Touch Flat Flag",
    image: "/patterns/2-touch-flat-bull-flag.png"
  },
  {
    value: "3 Touch Flat Bull Flag",
    label: "3 Touch Flat Flag",
    image: "/patterns/3-touch-flat-bull-flag.png"
  },
  {
    value: "Symmetrical Bull Triangle",
    label: "Symmetrical Triangle",
    image: "/patterns/symmetrical-bull-triangle.png"
  },
  {
    value: "Expanding Bull Triangle",
    label: "Expanding Triangle",
    image: "/patterns/expanding-bull-triangle.png"
  },
  { value: "Advanced Bull Flag", label: "Advanced Flag", image: "/patterns/advanced-bull-flag.png" },
  { value: "Falling Wedge", label: "Falling Wedge", image: "/patterns/falling-wedge.png" },
  { value: "Descending Channel", label: "Descending Channel", image: "/patterns/descending-channel.png" },
  { isGroup: true, label: "Bullish Reversals", color: "#0079cf" },
  {
    value: "Inverse Head & Shoulders",
    label: "Inverse Head & Shoulders",
    image: "/patterns/inverse-head-shoulders.png"
  },
  { value: "Double Bottom", label: "Double Bottom", image: "/patterns/double-bottom.png" },
  { value: "Triple Bottom", label: "Triple Bottom", image: "/patterns/triple-bottom.png" },
  { value: "The Arc", label: "The Arc", image: "/patterns/bullish-arc.png" },
];
